export default async () => {
  document.querySelector('main')?.empty?.();

  await create({
    element: 'section',
    parent: 'main',
    class: 'main-blog',
    isGrid: true,
    content: [
      { element: 'h2', text: dic?.branding?.menu?.blog || 'Blog', class: 'center' },
      {
        element: 'p',
        text: dic?.message?.blogIntro || 'Conteudo editorial e atualizacoes do produto serao exibidos aqui.'
      }
    ]
  });
};
